import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { COMMUNITY_ORDER_TYPES } from "./CommunitiesList";
const CommunitySortButton = ({ onClick, isSelected, children, showComma = true, }) => {
    return (React.createElement(PeekStack, { direction: "row" },
        React.createElement(PeekTypography, { onClick: onClick, sx: {
                boxShadow: "none",
                transition: "color 0.5s ease",
                textDecoration: isSelected ? "underline" : "none",
                fontWeight: isSelected ? "500" : "400",
                ":hover": {
                    cursor: "pointer",
                    background: "transparent",
                    color: "secondary.main",
                },
            } }, children),
        showComma && React.createElement(PeekTypography, null, ",")));
};
export const CommunitiesListSort = ({ communityOrder, setCommunityOrder }) => {
    const intl = useIntl();
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.5 },
        React.createElement(PeekTypography, null,
            intl.formatMessage(messages.communityOrderBy),
            " "),
        React.createElement(CommunitySortButton, { onClick: () => setCommunityOrder(COMMUNITY_ORDER_TYPES.ASC), isSelected: communityOrder === COMMUNITY_ORDER_TYPES.ASC }, intl.formatMessage(messages.communityOrderByOldest)),
        React.createElement(CommunitySortButton, { onClick: () => setCommunityOrder(COMMUNITY_ORDER_TYPES.DESC), isSelected: communityOrder === COMMUNITY_ORDER_TYPES.DESC }, intl.formatMessage(messages.communityOrderByNewest)),
        React.createElement(CommunitySortButton, { onClick: () => setCommunityOrder(COMMUNITY_ORDER_TYPES.REQUESTS), isSelected: communityOrder === COMMUNITY_ORDER_TYPES.REQUESTS, showComma: false }, intl.formatMessage(messages.communityMostRequests))));
};
export default CommunitiesListSort;
